<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <base-bread-crumb :items="breadcrumbs" class="bg-white" />
      </b-col>
    </b-row>

    <form-micro-credential
      v-if="learningUnit && mode == 'general'"
      :learning-unit="learningUnit"
      :user="user"
      :editable="editable"
      :fallback="fallBackRoute"
    />

    <form-micro-credential-learning
      v-if="learningUnit && mode == 'learning'"
      :learning-unit="learningUnit"
      :user="user"
      :fallback="fallBackRoute"
    />

    <form-micro-credential-method
      v-if="learningUnit && mode == 'method'"
      :learning-unit="learningUnit"
      :fallback="fallBackRoute"
    />
  </b-container>
</template>

<script>
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
import FormMicroCredential from './components/FormMicroCredential.vue';
import FormMicroCredentialLearning from './components/FormMicroCredentialLearning.vue';
import FormMicroCredentialMethod from './components/FormMicroCredentialMethod.vue';
import { userInfoMixin } from '@/mixins';
import LearningUnit from '@/models/LearningUnit';

export default {
  components: {
    BaseBreadCrumb,
    FormMicroCredential,
    FormMicroCredentialLearning,
    FormMicroCredentialMethod
  },

  mixins: [userInfoMixin],

  computed: {
    learningUnitId() {
      return this.$route.params.learningUnitId;
    },

    learningUnit() {
      return LearningUnit.find(this.learningUnitId);
    },

    mode() {
      return this.$route.query.mode || 'general';
    },

    breadcrumbs() {
      let activeBreadCrumb;

      switch (this.mode) {
        case 'learning':
          activeBreadCrumb = {
            key: 'edit-learning',
            name: 'Edit learning components'
          };
          break;

        case 'method':
          activeBreadCrumb = {
            key: 'edit-method-components',
            name: 'Edit method components'
          };
          break;

        default:
          activeBreadCrumb = {
            key: 'edit-credential',
            name: 'Edit micro-credentials'
          };
          break;
      }

      return [
        {
          key: 'review-learning-unit',
          name: 'Review Submitted Micro-Credentials',
          to: {
            name: 'review-learning-unit'
          }
        },
        {
          key: 'review-learning-unit-info',
          name: this.learningUnit?.name ?? 'Micro-Credential',
          to: {
            name: 'review-learning-unit/edit',
            params: {
              learningUnitId: this.learningUnitId
            }
          }
        },
        {
          ...activeBreadCrumb,
          active: true
        }
      ];
    },

    editable() {
      return {
        title: false,
        description: false,
        media_detail: false,
        badge_image: false,
        type: false,
        category: false,
        competency: false,
        sector: true,
        skills: true,
        price_toggle: false,
        price_input: true,
        who_this_for: false,
        developer: false
      };
    },

    fallBackRoute() {
      return {
        name: 'review-learning-unit/edit',
        params: {
          learningUnitId: this.learningUnitId
        }
      };
    }
  },

  watch: {
    '$route.params': {
      immediate: true,
      handler: 'fetch'
    }
  },

  methods: {
    async fetch() {
      if (!this.learningUnitId) return;
      try {
        LearningUnit.delete(this.learningUnitId);
        await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);
      } catch (error) {
        this.$toast.error('Cannot load Micro-Credential, please try again');
      }
    }
  }
};
</script>
